import { createSlice } from "@reduxjs/toolkit";
import { addEditReviewsAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const addEditReviewSlice = createSlice({
  name: "addEditReview",
  initialState: data,
  reducers: {
    addEditReviewSlice(state) {
      state.isLoading = true;
    },
    addEditReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    addEditReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    addEditReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const addEditReviewHandler = (org_id:string,data:any) => async (dispatch: any) => {
  try {
    dispatch(addEditReviewAction.addEditReviewSlice());
    const response: any = await addEditReviewsAPI(org_id,data);
    dispatch(addEditReviewAction.addEditReviewSliceSuccess(response));
    showSuccessToast(response?.message)
    return response?.results
  } catch (e: any) {
    dispatch(addEditReviewAction.addEditReviewSliceFailure(e?.response?.data?.message));
    dispatch(addEditReviewAction.addEditReviewSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default addEditReviewSlice.reducer;
export const addEditReviewAction = addEditReviewSlice.actions;
